import { IntegrationSystem } from "../../types";
import { BrevoConnectView } from "./ConnectView";
import { BrevoSettingsView } from "./SettingsView";

export const BrevoSystem: IntegrationSystem = {
  ConnectView: BrevoConnectView,
  SettingsView: BrevoSettingsView
};

export { brevoIntegrationReducer } from "./redux";
